<script lang="ts" setup>
import ToggleButton from "@/components/atoms/button/ToggleButton.vue";

defineProps({
  hiringOnly: {
    type: Boolean,
    default: false
  }
});

const emits = defineEmits(["toggle-hiring-only"]);

const onToggleHiringOnly = () => {
  emits("toggle-hiring-only");
};
</script>

<template>
  <div class="d-inline-block">
    <div
      class="hiring-only-order-button"
      data-testid="hiring-only-order-button"
    >
      募集中のお仕事のみ表示
      <ToggleButton :checked="hiringOnly" @click="onToggleHiringOnly" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.hiring-only-order-button {
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  color: #31373f;
}
</style>
